import React from 'react'
import { Outlet } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'

const App = () => {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  )
}

export default App
